import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Camera, KeyRound, LogOut, Menu } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { LangSwitch } from "../lib/i18n";
import Scanner from "./Scanner";

export const APP_VERSION = "V.1.1";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";
import { api, errMsg } from "../lib/api";

export const NAV = [
  { section: "UTAMA / 主页", items: [{ to: "/dashboard", icon: "▦", t: "Dashboard", c: "仪表盘", p: "STOCK" }] },
  { section: "OPERASIONAL / 作业", items: [
    { to: "/masuk", icon: "↧", t: "Barang Masuk", c: "物料入库", p: "INBOUND" },
    { to: "/keluar", icon: "↥", t: "Barang Keluar", c: "物料出库", p: "OUTBOUND" },
    { to: "/verifikasi", icon: "✓", t: "Scan & Verifikasi", c: "扫码确认", p: "VERIFY" },
  ] },
  { section: "STOCK / 库存", items: [
    { to: "/cek", icon: "⌕", t: "Cek Stock", c: "查询库存", p: "STOCK" },
    { to: "/stockdata", icon: "▤", t: "Data Stock", c: "库存数据", p: "STOCK" },
    { to: "/opname", icon: "≋", t: "Stock Opname", c: "库存盘点", p: "VERIFY" },
  ] },
  { section: "PERENCANAAN / 计划", items: [
    { to: "/todo/reservation", icon: "◆", t: "Material Reservation", c: "物料预留", p: "RESERVATION" },
    { to: "/todo/allocation", icon: "◧", t: "Allocation & Shortage", c: "分配与短缺", p: "RESERVATION" },
    { to: "/todo/requirement", icon: "☰", t: "Requirement Planning", c: "物料需求计划", p: "REQUIREMENT" },
  ] },
  { section: "REPORT / 报表", items: [
    { to: "/activity", icon: "◫", t: "Aktivitas & Riwayat", c: "活动与历史", p: "ACTIVITY_REPORT" },
    { to: "/riwayat", icon: "≣", t: "Riwayat Lengkap", c: "完整历史", p: "ACTIVITY_REPORT" },
    { to: "/proyek", icon: "◈", t: "Status Proyek", c: "项目物料状态", p: "STOCK" },
    { to: "/ai-search", icon: "✦", t: "Asisten Data AI", c: "AI 数据助手", p: "STOCK" },
    { to: "/todo/analytics", icon: "▥", t: "Analitik & Report", c: "数据分析与报表", p: "ACTIVITY_REPORT" },
    { to: "/tonnage", icon: "⚖", t: "Tonnage Report", c: "吨位报表", p: "ACTIVITY_REPORT" },
  ] },
  { section: "ADMIN / 管理", items: [
    { to: "/outrevision", icon: "↻", t: "Pusat Revisi", c: "数据修正中心", role: "ADMINISTRATOR" },
    { to: "/todo/masteredit", icon: "✎", t: "Koreksi Master Data", c: "主数据修正", p: "MASTER_EDIT" },
    { to: "/users", icon: "⚙", t: "User & Role", c: "用户管理", p: "USER_ADMIN" },
  ] },
  { section: "PENGEMBANGAN BARU / 新功能", items: [
    { to: "/uji-lapangan", icon: "☑", t: "Uji HP & Printer", c: "手机与打印测试", role: "ADMINISTRATOR" },
    { to: "/hapus", icon: "⌫", t: "Hapus Data", c: "删除数据", role: "ADMINISTRATOR" },
  ] },
];

const VENDOR_MENU = ["/keluar", "/cek", "/stockdata", "/activity", "/riwayat", "/ai-search"];
export const allowed = (user, it) =>
  user.role === "VENDOR" ? VENDOR_MENU.includes(it.to) : it.role ? user.role === it.role : it.roles ? it.roles.includes(user.role) : user.permissions.includes(it.p);

function Clock() {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const d = now.toLocaleDateString("id-ID", { timeZone: "Asia/Jakarta", day: "numeric", month: "long", year: "numeric" });
  const zh = now.toLocaleDateString("zh-CN", { timeZone: "Asia/Jakarta", year: "numeric", month: "long", day: "numeric" });
  return (
    <div className="topbar-clock" data-testid="topbar-clock">
      <strong>{d} / {zh}</strong>
      <small>{now.toLocaleTimeString("id-ID", { timeZone: "Asia/Jakarta" })}</small>
    </div>
  );
}

function ChangePassword({ onClose }) {
  const [o, setO] = useState("");
  const [n, setN] = useState("");
  const submit = async () => {
    try {
      await api.post("/auth/change-password", { old_password: o, new_password: n });
      toast.success("Password diganti / 密码已修改");
      onClose();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="modal-overlay" data-testid="change-password-modal">
      <div className="modal-box small">
        <h3>Ganti Password / 修改密码</h3>
        <label>Password Lama / 原密码</label>
        <input type="password" value={o} onChange={(e) => setO(e.target.value)} data-testid="old-password-input" />
        <label>Password Baru (min. 8) / 新密码</label>
        <input type="password" value={n} onChange={(e) => setN(e.target.value)} data-testid="new-password-input" />
        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onClose} data-testid="change-password-cancel">Batal / 取消</button>
          <button className="btn btn-primary" onClick={submit} data-testid="change-password-submit">Simpan / 保存</button>
        </div>
      </div>
    </div>
  );
}

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const [pw, setPw] = useState(false);
  const [scan, setScan] = useState(false);
  const navigate = useNavigate();
  const onScan = (text) => {
    setScan(false);
    const m = text.match(/MAT-\d{6}-\d{4}/i);
    const bid = (m ? m[0] : text).toUpperCase();
    navigate(user.role === "VENDOR" || !user.permissions.includes("STOCK") ? `/keluar?barcode=${bid}` : `/cek?barcode=${bid}`);
  };
  const loc = useLocation();
  const current = NAV.flatMap((s) => s.items).find((i) => loc.pathname.startsWith(i.to));
  useEffect(() => { setOpen(false); }, [loc.pathname]);
  return (
    <div className={`app-shell ${open ? "sidebar-open" : ""}`}>
      <aside className="app-sidebar" data-testid="app-sidebar">
        <div className="sidebar-brand">
          <img src="/honglu-logo.png" alt="HONGLU" className="brand-logo" />
          <div className="brand-copy"><b>PT HONGLU BAJA INDONESIA</b><small>WAREHOUSE BARCODE SYSTEM</small></div>
        </div>
        <nav className="app-nav">
          {NAV.map((s) => {
            const items = s.items.filter((i) => allowed(user, i));
            if (!items.length) return null;
            return (
              <div key={s.section}>
                <div className="nav-section-label">{s.section}</div>
                {items.map((i) => (
                  <NavLink key={i.to} to={i.to} className={({ isActive }) => `tab-button ${isActive ? "active" : ""}`} data-testid={`nav-${i.to.split("/").pop()}`}>
                    <span className="nav-icon">{i.icon}</span>
                    <span className="nav-copy"><b>{i.t}</b><small>{i.c}</small></span>
                  </NavLink>
                ))}
              </div>
            );
          })}
        </nav>
        <div className="sidebar-user-card">
          <div className="sidebar-avatar">{user.name[0]}</div>
          <div className="sidebar-user-info"><strong>{user.name} ({user.user_id})</strong><small>Role: {user.role}</small></div>
          <div className="sidebar-user-actions">
            {user.role !== "TAMU" && <button title="Ganti Password" onClick={() => setPw(true)} data-testid="change-password-btn"><KeyRound size={14} /></button>}
            <button title="Logout" onClick={logout} data-testid="logout-btn"><LogOut size={14} /></button>
          </div>
        </div>
      </aside>
      <div className="sidebar-backdrop" onClick={() => setOpen(false)} />
      <main className="app-main">
        <header className="app-topbar">
          <div className="topbar-left">
            <button className="mobile-menu-button" onClick={() => setOpen(true)} data-testid="mobile-menu-btn"><Menu size={20} /></button>
            <h1 data-testid="page-title">{current ? `${current.t} / ${current.c}` : "WMS / 仓库系统"}</h1>
          </div>
          <div className="topbar-right">
            <button className="topbar-scan" onClick={() => setScan(true)} title="Scan Barcode / 扫码" data-testid="global-scan-btn"><Camera size={18} /><span>Scan</span></button>
            <LangSwitch />
            <Clock />
            <div className="topbar-user"><span className="topbar-user-dot" /><div><strong>{user.name}</strong><small>{user.role}</small></div></div>
          </div>
        </header>
        <div className="app-content">
          {children}
          <div className="app-version" data-testid="app-version" title="DEV REPLIKA • Baseline G27">{APP_VERSION}</div>
        </div>
      </main>
      {pw && <ChangePassword onClose={() => setPw(false)} />}
      {scan && <Scanner onResult={onScan} onClose={() => setScan(false)} />}
    </div>
  );
}
